let kuvagalleria = new SimpleLightbox('.simplelightbox', {
    uniqueImages: false,
    disableRightClick: true,
    history: false,
    sourceAttr: 'data-src',
});

/*
defaultOptions = {
    sourceAttr: 'href',
    overlay: true,
    overlayOpacity: 0.7,
    spinner: true,
    nav: true,
    navText: ['&lsaquo;', '&rsaquo;'],
    captions: true,
    captionDelay: 0,
    captionSelector: 'img',
    captionType: 'attr',
    captionsData: 'title',
    captionPosition: 'bottom',
    captionClass: '',
    captionHTML: true,
    close: true,
    closeText: '&times;',
    swipeClose: true,
    showCounter: true,
    fileExt: 'png|jpg|jpeg|gif|webp|avif',
    animationSlide: true,
    animationSpeed: 250,
    preloading: true,
    enableKeyboard: true,
    loop: true,
    rel: false,
    docClose: true,
    swipeTolerance: 50,
    className: 'simple-lightbox',
    widthRatio: 0.8,
    heightRatio: 0.9,
    scaleImageToRatio: false,
    disableRightClick: false,
    disableScroll: true,
    alertError: true,
    alertErrorMessage: 'Image not found, next image will be loaded',
    additionalHtml: false,
    history: true,
    throttleInterval: 0,
    doubleTapZoom: 2,
    maxZoom: 10,
    htmlClass: 'has-lightbox',
    rtl: false,
    fixedClass: 'sl-fixed',
    fadeSpeed: 300,
    uniqueImages: true,
    focus: true,
    scrollZoom: true,
    scrollZoomFactor: 0.5,
    download: false
};
*/
